export default "__VITE_ASSET__1f8ad4a4__"